import client, { Response } from './client';
import { Address } from '../../types/order';
import { DeliveryQuote, IDeliveryZone } from '../../types/delivery';

export type CreateDeliveryQuoteParams = Address & {
  dropoff_time: null | string;
};

export type FindDeliveryZoneParams = {
  address?: null | string;
  zip_code?: null | string;
  lat?: null | number;
  lng?: null | number;
};

export const createDeliveryQuote = (
  storeId: string,
  data: CreateDeliveryQuoteParams,
): Response<DeliveryQuote> => client.post(`/stores/${storeId}/delivery-quotes`, data);

export const findDeliveryZone = (
  storeId: string,
  params: FindDeliveryZoneParams,
): Response<IDeliveryZone> => client.get(`/stores/${storeId}/delivery-zones`, { params });
